import React, { useState } from 'react';
import {
    ChoiceGroup,
    Dialog,
    DialogType,
    Stack,
    DialogFooter,
    PrimaryButton,
    DefaultButton,
    IChoiceGroupOption,
} from '@fluentui/react';
import { appStyles } from '../../../../helpers';
import {
    selectDefaultFolderModalStep,
    selectFormDefaultFolderScope,
} from '../../../../store/selectors/defaultFolder';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { selectTranslate } from '../../../../store/selectors/ui';
// eslint-disable-next-line max-len
import { DefaultFolderModalStep } from '../../../../store/reducers/defaultFolder/reducer';
import {
    setDefaultFolderModalStep,
    setFormDefaultFolderScope,
} from '../../../../store/actions/defaultFolder/actionCreators';
import { MappingType } from '@sendent/nextcloud-api';
// eslint-disable-next-line max-len
import { clearDefaultFolderFormData } from '../../../../store/actions/defaultFolder/thunks';

export const SetFolderModal = () => {
    const dispatch = useAppDispatch();
    const defaultFolderModalStep = useAppSelector(selectDefaultFolderModalStep);
    const formDefaultFolderScope = useAppSelector(selectFormDefaultFolderScope);
    const translate = useAppSelector(selectTranslate);

    const [selectedScope, setSelectedScope] = useState<MappingType>(
        formDefaultFolderScope || MappingType.Channel,
    );

    const isSetDefaultOpen =
        defaultFolderModalStep === DefaultFolderModalStep.SetFolder;

    const scopeOptions: IChoiceGroupOption[] = [
        {
            key: MappingType.Channel,
            text: translate('set_default_folder_for_channel'),
        },
        {
            key: MappingType.Team,
            text: translate('set_default_folder_for_team'),
        },
    ];

    return (
        <Dialog
            styles={appStyles.DialogStyle}
            hidden={!isSetDefaultOpen}
            onDismiss={() => dispatch(setDefaultFolderModalStep(null))}
            dialogContentProps={{
                type: DialogType.normal,
                title: translate('set_default_folder'),
            }}
        >
            <Stack tokens={{ childrenGap: 12 }}>
                <ChoiceGroup
                    selectedKey={selectedScope}
                    options={scopeOptions}
                    onChange={(_, option) =>
                        setSelectedScope(
                            (option?.key as MappingType) || MappingType.Channel,
                        )
                    }
                />
            </Stack>
            <DialogFooter>
                <DefaultButton
                    styles={appStyles.primaryButtonReverse}
                    text={translate('button_cancel')}
                    onClick={() => {
                        dispatch(clearDefaultFolderFormData());
                        dispatch(setDefaultFolderModalStep(null));
                    }}
                />
                <PrimaryButton
                    styles={appStyles.primaryButton}
                    text={translate('button_confirm')}
                    onClick={() => {
                        dispatch(
                            setDefaultFolderModalStep(
                                DefaultFolderModalStep.CircleSelection,
                            ),
                        );
                        dispatch(setFormDefaultFolderScope(selectedScope));
                    }}
                />
            </DialogFooter>
        </Dialog>
    );
};
